/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Query } from '@apollo/client/react/components';
import ReactHtmlParser from 'react-html-parser';
import findContent from '../../../../../gql/queries/findContent';
import CustomModal from '../../../../../components/CustomModal';

/*
 * This component is meant to be a collapsible tool tip in mobile view 
 * On desktop view, this is a modal
 */

const RegulatoryFeeInfo = ({ regulatoryFeesForTooltip, ...props }) => {

    const regulatoryFeesTooltipQuery = findContent({
        brand: 'global',
        contentType: 'regulatory_fees',
    });

    // if there is bottle fee
    const isContainsBottleFee = regulatoryFeesForTooltip.bottleFee > 0;
    // if there is delivery fee
    const isContainsDeliveryFee = regulatoryFeesForTooltip.deliveryFee > 0;

    return (
        <Query query={regulatoryFeesTooltipQuery}>
            {({ data, loading, error }) => {
                let toolTipMessages = [];
                if (loading) {
                    toolTipMessages = [{ content: null, title: 'Tooltip is loading...' }];
                };
                if (data) {
                    if (!data.findContent.content) { // when aggregator is not working, data.findContent.content === null
                        toolTipMessages = [{ content: null, title: 'An error has occured while loading this tooltip.' }];
                    } else {
                        toolTipMessages = data.findContent?.content?.entries?.filter(({ content, title }) => {
                            return (
                                (title === 'Bottle Deposit Fee' && isContainsBottleFee)
                                || (title === 'Colorado Retail Delivery Fee' && isContainsDeliveryFee)
                            );
                        })
                    }
                }
                if (error) {
                    toolTipMessages = [{ content: null, title: 'An error occurred while loading information.' }];
                }
                if (props.deviceType === 'desktop') {
                    return (
                        <CustomModal
                            open
                            aria-labelledby="regulatory-fee-modal"
                            aria-describedby="information modal on the regulatory fees"
                            onClose={() => props.setShowRegulatoryFeeInfo(false)}
                            modalSize="sm"
                        >
                            <p style={{ fontSize: '20px', fontWeight: 700, margin: '0', maxWidth: '80%', marginBottom: '20px' }} id="modal-title">This Order Includes The Following Regulatory Fee(s): </p>
                            {
                                toolTipMessages?.map(({ content, title }) => (
                                    <>
                                        <p style={{ fontSize: '16px', margin: '0', fontWeight: 700 }}>{title}</p>
                                        <div>{ReactHtmlParser(content)}</div>
                                    </>
                                ))
                            }
                        </CustomModal>
                    );
                }
                return (
                    <div style={{ backgroundColor: '#e0e0e0', borderRadius: '6px', padding: '10px' }} >
                        {
                            toolTipMessages?.map(({ content, title }) => (
                                <>
                                    <p style={{ fontSize: '14px', margin: '0', fontWeight: 700 }}>{title}</p>
                                    <div>{ReactHtmlParser(content)}</div>
                                </>
                            ))
                        }
                    </div>
                )
            }}
        </Query>
    )
};

export default RegulatoryFeeInfo;